export { default } from './svg/settings.svg';
